<div class="card-offers-widget" [class.card-offers-widget--small]="size === 'small'"
    [class.card-offers-widget--medium]="size === 'medium'" [class.card-offers-widget--half]="size === 'half'"
    [class.card-offers-widget--full]="size === 'full'">

    <!-- Header -->
    <div class="card-offers-widget__header">
        <!-- Title and Count -->
        <div class="card-offers-widget__title-section">
            <span class="card-offers-widget__title">{{ title }}</span>
            <span class="card-offers-widget__count">{{ cardOffers.length }}</span>
        </div>

        <div class="card-offers-widget__header-actions">
            <!-- Navigation Arrows -->
            <div class="card-offers-widget__nav-controls" *ngIf="!isEditMode">
                <button class="card-offers-widget__nav-arrow" [disabled]="!canGoPrevious()" (click)="previousCard()">
                    <img src="assets/icons/img-image-1.svg" alt="Previous">
                </button>
                <button class="card-offers-widget__nav-arrow" [disabled]="!canGoNext()" (click)="nextCard()">
                    <img src="assets/icons/img-arrow-right-2.svg" alt="Next">
                </button>
            </div>

            <!-- Edit Icon -->
            <ng-container *ngIf="isEditMode">
                <div cdkOverlayOrigin #editTrigger="cdkOverlayOrigin" (click)="toggleSizeDropdown(index, $event)"
                    class="ai-advice-widget__icon-container">
                    <div class="ai-advice-widget__icon">
                        <img src="assets/icons/widget/pencil.svg" alt="Edit">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <!-- Card Slider -->
    <div class="card-offers-widget__slider" #sliderContainer>
        <div class="card-offers-widget__slider-track" [style.transform]="getSliderTransform()">
            <div *ngFor="let card of cardOffers; let i = index" class="card-offers-widget__card"
                [style.width.px]="cardWidth">
                <!-- Card Header -->
                <div class="card-offers-widget__card-header">
                    <img class="card-offers-widget__card-image no-dark-filter" [src]="card.cardImage"
                        [alt]="card.cardTitle">

                    <div class="card-offers-widget__card-title-section">
                        <div class="card-offers-widget__card-title">{{ card.cardTitle }}</div>
                        <button class="card-offers-widget__select-button" (click)="onSelectCard(card)">
                            Select
                        </button>
                    </div>
                </div>

                <!-- Card Details -->
                <div class="card-offers-widget__card-details">
                    <!-- APR -->
                    <div class="card-offers-widget__detail-row">
                        <div class="card-offers-widget__detail-item">
                            <div class="card-offers-widget__detail-label">APR</div>
                            <div class="card-offers-widget__detail-value">{{ card.apr }}</div>
                        </div>
                    </div>
                    <div class="card-offers-widget__divider"></div>

                    <!-- Loan Amount -->
                    <div class="card-offers-widget__detail-row">
                        <div class="card-offers-widget__detail-item">
                            <div class="card-offers-widget__detail-label">Loan amount</div>
                            <div class="card-offers-widget__detail-value">{{ card.loanAmount }}</div>
                        </div>
                    </div>
                    <div class="card-offers-widget__divider"></div>

                    <!-- Loan Term -->
                    <div class="card-offers-widget__detail-row">
                        <div class="card-offers-widget__detail-item">
                            <div class="card-offers-widget__detail-label">Loan term</div>
                            <div class="card-offers-widget__detail-value">{{ card.loanTerm }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>